import {RemoteGetReverseGeocode} from 'data/usecases/private/profile/remote-get-reverse-geocode';
import {GetReverseGeocode} from 'domain/usecases/private/profile/get-reverse-geocode';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetReverseGeocode = (): GetReverseGeocode =>
	new RemoteGetReverseGeocode(
		makeBFFApiUrl(ProfileChangeDataEndpoints.reverseGeocode),
		makeAuthorizeHttpClientDecorator(),
	);
